import { jsx as _jsx } from "react/jsx-runtime";
import { useHistory } from 'react-router-dom';
import { DropdownButton } from '@famly/mf_input_dropdown-button';
import { useBreakpoints } from '@famly/mf_util_breakpoints';
import { getFromLocalStorage, saveToLocalStorage } from '@famly/stat_ts-utils_local-storage';
import { languageOptions } from '@famly/vet_ts-utils_languages';
import { isSupportedLanguage } from 'web-app/setup/locale-setup';
import { LoginTestAttributes } from './test-attributes';
import { useLoginScreenTranslationsJson } from './login-screen/use-login-screen-translations-json';
const supportedLanguageOptions = languageOptions.filter(option => isSupportedLanguage(option.value));
export const LoginLanguagePicker = () => {
    const { t } = useLoginScreenTranslationsJson();
    const history = useHistory();
    const { isTabletPortraitAndLarger } = useBreakpoints();
    const savedLocale = getFromLocalStorage('locale');
    const label = t($ => $.languagePickerLabel);
    const switchLanguage = (locale) => {
        // Logged-out screens cache i18next.t and the MF provider fixes its language at boot, so the new
        // language only shows after a reload; a leftover ?locale would switch it straight back.
        saveToLocalStorage('locale', locale);
        const searchParams = new URLSearchParams(history.location.search);
        searchParams.delete('locale');
        history.replace({ search: searchParams.toString() });
        window.location.reload();
    };
    const savedOption = supportedLanguageOptions.find(option => option.value === savedLocale);
    // A phone has only room for the language code next to the logo.
    const text = isTabletPortraitAndLarger ? savedOption === null || savedOption === void 0 ? void 0 : savedOption.label : savedOption === null || savedOption === void 0 ? void 0 : savedOption.value.split('_')[0].toUpperCase();
    return (_jsx(DropdownButton, { variant: "transparent", icon: "language", text: text !== null && text !== void 0 ? text : '', "aria-label": label, dropdownPlacement: "end", "data-e2e-id": LoginTestAttributes.languagePicker, options: supportedLanguageOptions.map(option => ({
            label: option.label,
            isSelected: option.value === savedLocale,
            onClick: () => switchLanguage(option.value),
        })) }));
};
